var BasketView = (function (BaseView) {
	return BaseView.extend({
		el: '@basket',
		displayRoutes: ['checkout'],

		initialize: function () {
			this.listenTo(this.model, 'change:IsEmpty', _.bind(this._checkEmpty, this));
		},

		_checkEmpty: function () {
			if (this.model.get('IsEmpty')) {
				this.display('checkout.empty');
			} else {
				this.display('checkout');
			}
		}
	});
})(BaseView);